var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"circleWrap"},[_c('circleGif',{staticClass:"circleGif",attrs:{"warning":_vm.scoreInfo.avg_score<60}}),_c('div',{staticClass:"circleContent"},[_c('div',{staticClass:"score-box"},[_c('div',{class:{ score: true, moneyWarn: _vm.scoreInfo.avg_score<60 ? true : false }},[_c('countTo',{attrs:{"val":_vm.scoreInfo.avg_score}})],1),_c('div',[_vm._v("分")])]),_c('div',{staticClass:"title"},[_c('a-tooltip',{attrs:{"placement":"top","overlayClassName":"achievementsTip"}},[_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("绩效")]),_c('template',{slot:"title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.tipconfig.achievementsTip)}})]),_c('div',{staticClass:"tips"})],2)],1)])],1),_c('polygonGif',{staticClass:"qualityScore",attrs:{"content":{
      title: '质量评分',
      rate: 40,
      score: _vm.scoreInfo.zl_score,
      monthRate: _vm.scoreInfo.qualityMonth,
      warn: _vm.scoreInfo.zl_score<60 ? true:false
    }}}),_c('polygonGif',{staticClass:"effectScore",attrs:{"content":{
      title: '有效时长评分',
      rate: 15,
      score: _vm.scoreInfo.hs_score,
      monthRate: _vm.scoreInfo.effectMonth,
      warn: _vm.scoreInfo.hs_score<60?true:false
    }}}),_c('polygonGif',{staticClass:"efficiencyScore",attrs:{"content":{
      title: '效率评分',
      rate: 30,
      score: _vm.scoreInfo.xl_score,
      monthRate: _vm.scoreInfo.effectiveMonth,
      warn: _vm.scoreInfo.xl_score<60?true:false
    }}}),_c('polygonGif',{staticClass:"productScore",attrs:{"content":{
      title: '产量评分',
      rate: 15,
      score: _vm.scoreInfo.cl_score,
      monthRate: _vm.scoreInfo.productMonth,
      warn: _vm.scoreInfo.cl_score<60?true:false
    }}}),_c('div',{staticClass:"light"}),_c('water-spread',{staticClass:"waterSpread"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }